import { clamp, defaultTo, pipe } from "ramda";

const Clock = (n: number) => String(n).padStart(2, "0");

export const formatClock = (sec?: number) => {
  const s = pipe(
    defaultTo(0 as number),
    (x: number) => (Number.isFinite(x) ? x : 0),
    Math.floor,
    (x: number) => clamp(0, Number.MAX_SAFE_INTEGER, x)
  )(sec as number);

  const h = Math.floor(s / 3600);

  const m = Math.floor((s % 3600) / 60);

  const r = s % 60;

  return h > 0 ? `${h}:${Clock(m)}:${Clock(r)}` : `${Clock(m)}:${Clock(r)}`;
};
